module.exports = __webpack_public_path__ + "static/media/banner_salon_membership_method.0bddc707.webp";